var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-full"},[_c('TopSales')],1),_c('div',{staticClass:"column is-full"},[_c('TopRevenue')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }